<template>
  <q-list
    v-if="isEnabled"
    :dense="dense"
    :separator="separator"
    :bordered="bordered"
    :class="props.class"
    :style="style"
    v-bind="$attrs"
  >
    <slot />
  </q-list>
  <div
    v-else
    variant="custom"
    v-bind="$attrs"
  >
    <div class="flex flex-col gap-2">
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFeatureFlags } from "@/composables/useFeatureFlags";

const { isEnabled: checkEnabled } = useFeatureFlags();
const isEnabled = checkEnabled("dtpList");
type Props = {
  dense?: boolean;
  separator?: boolean;
  bordered?: boolean;
  class?: string;
  style?: string | Record<string, any>;
};

const props = withDefaults(defineProps<Props>(), {
  dense: false,
  separator: false,
  bordered: false,
  class: undefined,
  style: undefined
});
</script>
